import pkg from "../../package.json";

/**
 * Configurações comuns a todos os ambientes: dev, hom e prod
 */
const common = {
  clientId: "54bcfa1d",
  clientVersion: pkg.version,
  clientRelease: "2021-06-30",
};

export default common;
